// Tuesday, 29 September 2026
// Change this version if you want to invalidate old data
export const INBOX_CACHE_INVALIDATION_VERSION = 1790640000;
export const DATA_VERSION = INBOX_CACHE_INVALIDATION_VERSION;
